import "./styles.scss";
import React, { FC } from "react";

interface IProps {
  title?: string,
  hasBorder: boolean,
  isHighlighted: boolean,
}

const CompanyDetailLoadMore: FC<IProps> = (props: IProps) => {
  const { title, hasBorder, isHighlighted } = props;
  return (
    <div className={`ps-company-detail-load-more${(title === undefined) ? "--hide" : "--show"}`}>
      <div className={`ps-company-detail-load-more${hasBorder ? "--border" : "--no-border"}`}>
        <span className={`ps-company-detail-load-more${isHighlighted ? "--highlight" : "--no-highlight"}`}>
          {title}
        </span>
      </div>
    </div>
  );
};

export default CompanyDetailLoadMore;
